// MobileDropdownMainItm.jsx
import React from "react";
import { BiChevronDown } from "react-icons/bi";

const MobileDropdownMainItm = ({ e, mainId, subDropdown, isSubOpen }) => {
    return (
        <div
            className="flex items-center justify-start pl-5"
            key={e.id}
            onClick={() => subDropdown(mainId, e.id)}
        >
            <button
                type="button"
                id="app-btn"
                className="px-3 py-2 text-left font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors"
            >
                {e.title}
            </button>
            <div className={`p-2 ${isSubOpen ? "open" : "close"}`}>
                <BiChevronDown
                    style={{ color: "black" }}
                    className={`faq-arrow transform transition-transform duration-200 ${
                        isSubOpen ? "rotate-90" : "rotate-0"
                    }`}
                />
            </div>
        </div>
    );
};

export default MobileDropdownMainItm;
